import Component from '@glimmer/component';
import { action, computed } from '@ember/object';
import { reads } from '@ember/object/computed';
import { tracked } from '@glimmer/tracking';
import { installDropdown } from 'mewe/utils/dropdown-utils';

export default class MwTextFormatting extends Component {
  @tracked dropdownOptions;

  constructor() {
    super(...arguments);

    installDropdown(this, 'dropdownOptions');
  }

  @action
  selectFormatting(type) {
    // https://sentry.qa-groupl.es/mewe/javascript/issues/2075/
    // https://sentry.qa-groupl.es/mewe/javascript/issues/2074/
    this.args.onFormatSelect?.(type);
  }
}
